// @flow
import CustomersAPI from '../services/CustomersAPI';
import type { Dispatch, GetState } from '../../../types/Store';
import type { CustomerInvitation } from '../types/RadioCustomer';
import RadioCustomer from '../types/RadioCustomer';
import { getToken, getStation } from '../../authentication/session/reducers/sessionReducer';

export const FETCH_ALL_CUSTOMERS = 'CustomerActions/FETCH_ALL_CUSTOMERS';
export const FETCH_ALL_CUSTOMERS_SUCCESS = 'CustomerActions/FETCH_ALL_CUSTOMERS_SUCCESS';
export const FETCH_ALL_CUSTOMERS_ERROR = 'CustomerActions/FETCH_ALL_CUSTOMERS_ERROR';

export const INVITE_CUSTOMER = 'CustomerActions/INVITE_CUSTOMER';
export const INVITE_CUSTOMER_SUCCESS = 'CustomerActions/INVITE_CUSTOMER_SUCCESS';
export const INVITE_CUSTOMER_ERROR = 'CustomerActions/INVITE_CUSTOMER_ERROR';

export const DELETE_CUSTOMER = 'CustomerActions/DELETE_CUSTOMER';
export const DELETE_CUSTOMER_SUCCESS = 'CustomerActions/DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_ERROR = 'CustomerActions/DELETE_CUSTOMER_ERROR';

export const fetchCustomers = () => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_ALL_CUSTOMERS });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      const customers = await CustomersAPI.fetchCustomersForStation(callSign, token);

      dispatch({ type: FETCH_ALL_CUSTOMERS_SUCCESS, customers: customers });
    } catch (error) {
      dispatch({ type: FETCH_ALL_CUSTOMERS_ERROR });
    }
  };
};

export const inviteCustomer = (customer: CustomerInvitation) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: INVITE_CUSTOMER });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      const invitedCustomer = await CustomersAPI.inviteCustomer(callSign, token, customer);
      dispatch({ type: INVITE_CUSTOMER_SUCCESS, customer: invitedCustomer });

      return invitedCustomer;
    } catch (error) {
      dispatch({ type: INVITE_CUSTOMER_ERROR });
    }

    return undefined;
  };
};

export const deleteCustomer = (customer: RadioCustomer) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: DELETE_CUSTOMER });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      await CustomersAPI.deleteCustomer(callSign, token, customer);
      dispatch({ type: DELETE_CUSTOMER_SUCCESS, customer: customer });
    } catch (error) {
      dispatch({ type: DELETE_CUSTOMER_ERROR });
    }
  };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/actions/customersActions.js